// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"441":"9168b047","459":"5e9485b6","817":"3b6d71f3","896":"c343065c"}[chunkId] + ".css";
};